import {
  Dropdown,
  DropdownButton,
  DropdownDivider,
  DropdownItem,
  DropdownLabel,
  DropdownMenu,
  NavbarItem,
} from '@accure/ui';
import {
  BadgeCheck,
  Bell,
  CircleUser,
  Clock,
  LogOut,
  MapPin,
  Server,
  Settings,
  Users,
} from 'lucide-react';

import { PageUrlKey } from '@/entities/page-url-key';
import { useAuth } from '@/hooks/use-auth';
import { useFeatureFlag } from '@/hooks/use-feature-flag';
import { useMe } from '@/hooks/use-me';

import { AppSidebarInternalIcon } from '../app-sidebar/app-sidebar-internal-icon';

import { ResetScenarioMenuItem } from './reset-scenario-menu-item';

export function AppHeaderAccount() {
  const auth = useAuth();
  const me = useMe();
  const featureFlag = useFeatureFlag();

  async function handleLogout() {
    await auth.logout(window.location.origin);
  }

  return (
    <Dropdown>
      <DropdownButton as={NavbarItem} data-testid="app-header-account-button">
        <CircleUser className="size-5 text-zinc-400" />
        <span className="max-sm:hidden">{me.firstName}</span>
      </DropdownButton>
      <DropdownMenu
        className="absolute right-0 z-50 min-w-64 rounded bg-zinc-50"
        anchor="top"
      >
        {featureFlag('alertNotifications') ? (
          <DropdownItem
            className="hover:bg-zinc-950/10"
            to="/account/alert-notifications"
          >
            <Bell data-slot="icon" />
            <DropdownLabel>Alert Notifications</DropdownLabel>
            <AppSidebarInternalIcon featureFlag="alertNotifications" />
          </DropdownItem>
        ) : null}
        {featureFlag('userPreferences') ? (
          <DropdownItem
            className="hover:bg-zinc-950/10"
            to="/account/user-preferences"
            data-testid="user-preferences-menu-item"
          >
            <Settings data-slot="icon" />
            <DropdownLabel>Preferences</DropdownLabel>
            <AppSidebarInternalIcon featureFlag="userPreferences" />
          </DropdownItem>
        ) : null}
        {featureFlag('contracts') ? (
          <DropdownItem
            className="hover:bg-zinc-950/10"
            to="/account/subscriptions"
          >
            <Clock data-slot="icon" />
            <DropdownLabel>Subscriptions</DropdownLabel>
            <AppSidebarInternalIcon featureFlag="contracts" />
          </DropdownItem>
        ) : null}
        {featureFlag('userManagement') ? (
          <>
            <DropdownDivider />
            <DropdownItem
              className="hover:bg-zinc-950/10"
              to="/account/user-management"
            >
              <Users data-slot="icon" />
              <DropdownLabel>User Management</DropdownLabel>
              <AppSidebarInternalIcon featureFlag="userManagement" />
            </DropdownItem>
          </>
        ) : null}

        {featureFlag('trustCenter') ? (
          <>
            <DropdownDivider />
            <DropdownItem
              className="hover:bg-zinc-950/10"
              to="/account/trust-center"
            >
              <BadgeCheck data-slot="icon" />
              <DropdownLabel>Trust Center</DropdownLabel>
              <AppSidebarInternalIcon featureFlag="trustCenter" />
            </DropdownItem>
          </>
        ) : null}
        {featureFlag('platformStatus') ? (
          <DropdownItem
            className="hover:bg-zinc-950/10"
            to="/account/availability"
          >
            <Server data-slot="icon" />
            <DropdownLabel>Platform Availability</DropdownLabel>
            <AppSidebarInternalIcon featureFlag="platformStatus" />
          </DropdownItem>
        ) : null}
        {me.config.id === '49' ? <ResetScenarioMenuItem /> : null}
        {featureFlag('siteviewConfigurator') ? (
          <DropdownItem
            className="hover:bg-zinc-950/10"
            to={`/${PageUrlKey.SITEVIEW_CONFIGURATOR}`}
          >
            <MapPin data-slot="icon" />
            <DropdownLabel>Siteview Configurator</DropdownLabel>
            <AppSidebarInternalIcon featureFlag="siteviewConfigurator" />
          </DropdownItem>
        ) : null}
        <DropdownDivider />
        <DropdownItem
          className="hover:bg-zinc-950/10"
          onClick={() => handleLogout()}
        >
          <LogOut data-slot="icon" />
          <DropdownLabel>Sign out</DropdownLabel>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
}
